import { render, staticRenderFns } from "./ShareAll.vue?vue&type=template&id=22b68a52&scoped=true&"
import script from "./ShareAll.vue?vue&type=script&lang=js&"
export * from "./ShareAll.vue?vue&type=script&lang=js&"
import style0 from "./ShareAll.vue?vue&type=style&index=0&id=22b68a52&scoped=true&lang=css&"
import style1 from "./ShareAll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b68a52",
  null
  
)

export default component.exports